<template>
  <div id="app">
    <div class="container" @click="randomGrid()">
      <div class="box-container">
        <div
          v-for="(grid, index) in randomArray"
          :key="index"
          :class="`box box-${grid}`"
        >
          <div class="circle"></div>
          <div class="triangle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      randomArray: []
    }
  },
  components: {},
  name: 'app',
  computed: {},
  methods: {
    randomGrid() {
      this.randomArray = []
      for (let i = 0; i < 16; i++) {
        this.randomArray.push(Math.floor(Math.random() * 6))
      }
    }
  },
  mounted() {
    this.randomGrid()
  }
}
</script>

<style lang="scss">
$blue: #2ab6fb;
$gray: #efefef;

$width: 360px;

body {
  background-color: white;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.container {
  position: relative;
  background-color: #caa472;
  width: $width;
  padding: 16px;
  border-radius: 12px;
  .box-container {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
  }
  .box {
    flex: 1 1 25%;
    background: #e9d2ff;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    position: relative;
    &.box-0 {
      background: $blue;
    }
    &.box-1 {
      background: $gray;
    }
    &.box-2 {
      background: $blue;
      position: relative;
      .circle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        background: $gray;
        border-radius: 50%;
      }
    }
    &.box-3 {
      background: $gray;
      .circle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px;
        height: 50px;
        background: $blue;
        border-radius: 50%;
      }
    }
    &.box-4 {
      position: relative;
      background: $gray;
      .triangle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-top: $width / 4 solid $blue;
        border-right: $width / 4 solid transparent;
      }
    }
    &.box-5 {
      position: relative;
      background: $gray;
      .triangle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-top: $width / 4 solid $blue;
        border-left: $width / 4 solid transparent;
      }
    }
    &.box-6 {
      position: relative;
      background: $gray;
      .triangle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-bottom: $width / 4 solid $blue;
        border-right: $width / 4 solid transparent;
      }
    }
    &.box-7 {
      position: relative;
      background: $gray;
      .triangle {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 0;
        height: 0;
        border-bottom: $width / 4 solid $blue;
        border-left: $width / 4 solid transparent;
      }
    }
  }
  .box:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
}
</style>
